import * as PropTypes from 'prop-types';
import * as React from 'react';

import { HonestWork } from '@cian/honestwork-component';
import { OwnerBadge } from '@cian/owner-badge-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import { UserInfoPopup } from '../../../common/components/user-info-popup';
import { IOfferHelper } from '../../../presenter';
import { IOffer, EUserTrustLevel } from '../../../types/offer';
import { PartnerTooltip } from '../../../components/PartnerTooltip';
import { IconWhitelist, IconBlacklist } from '../../../common/components/user-info-popup/icons';
import { getIsFromBuilderFromContext } from '../../../utils/suburban';
import * as styles from './Agent.css';

export interface IAgentContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
  countrysideOffersBuilderBadge: boolean;
}

export class Agent extends React.Component {
  public context: IAgentContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    countrysideOffersBuilderBadge: PropTypes.bool,
  };

  public render() {
    const { offer, offerHelper } = this.context;

    const { isByHomeowner } = offer;

    const isFromBuilder = getIsFromBuilderFromContext(this.context);
    const isFromSeller = offerHelper.isFromSeller();
    const userId = offerHelper.presenters.getCianUserId();
    const userPersonalRating = offerHelper.presenters.getUserPersonalRating();

    const userIdQuery = userId ? `id_user=${userId}&` : '';
    const offerTypeForUserUrl: string = offer.offerType === 'commercial'
      ? 'offices' : offer.offerType;

    if (!isFromBuilder && !isFromSeller && !isByHomeowner && !userPersonalRating) {
      return <div />;
    }

    return (
      <div className={styles['agent']} onClick={this.handleClickWithStopPropagation}>
        <UserInfoPopup
          isReverseOrder
          content={this.renderBlock()}
          userInfoStyle={styles['user-info']}
          userInfoStyleAction={styles['user-info-action']}
        />
        {offer.isTop3 && (
          <a
            href={`/cat.php?${userIdQuery}deal_type=${offer.dealType}&${offerTypeForUserUrl}=yes&engine_version=2`}
            className={styles['other-offers']}
            target="_blank"
          >
            Ещё объекты
          </a>
        )}
      </div>
    );
  }

  private renderBlock() {
    const { offer, offerHelper } = this.context;

    const { isByHomeowner, user } = offer;

    const isLeadFactory = offerHelper.isLeadFactory();
    const isFromBuilder = getIsFromBuilderFromContext(this.context);
    const isFromSeller = offerHelper.isFromSeller();
    const isHomeownerVerified = offerHelper.isHomeownerVerified();
    const verifyWay = offerHelper.getVerifyWay();
    const userPersonalRating = offerHelper.presenters.getUserPersonalRating();
    const userTrustLevel = offerHelper.presenters.getUserTrustLevel();
    const isHonestwork = userTrustLevel === EUserTrustLevel.Involved;
    const isCianPartner = !!(user && user.isCianPartner);

    return (
      <div className={styles['main-info']}>
        <div {...mergeStyles([
          styles['badge-container'],
          styles['agent-section'],
        ])}>
          {isHonestwork &&
            <div
              onClick={this.handleClickWithStopPropagation}
              {...mergeStyles([
                styles['badge'],
              ])}
            >
              <HonestWork/>
            </div>
          }

          {isFromBuilder && !isLeadFactory &&
            <div
              {...mergeStyles([
                styles['badge'],
                styles['text-badge'],
                styles['green'],
              ])}
            >
              Застройщик
            </div>
          }

          {!isFromBuilder && isFromSeller && !isLeadFactory &&
            <div
              {...mergeStyles([
                styles['badge'],
                styles['text-badge'],
                styles['green'],
              ])}
            >
              Представитель<br/>
              застройщика
            </div>
          }

          {isByHomeowner &&
            <span className={styles['owner-badge-wrapper']}>
              <OwnerBadge isVerified={isHomeownerVerified} verifyWay={verifyWay} />
            </span>
          }

          {isCianPartner && (
            <PartnerTooltip
              master={<div {...mergeStyles([styles['badge'], styles['text-badge'], styles['green']])}>Партнёр</div>}
            />
          )}

          {userPersonalRating === 'positive' &&
            <div>
              <IconWhitelist isActive />
            </div>
          }

          {userPersonalRating === 'negative' &&
            <div>
              <IconBlacklist isActive />
            </div>
          }
        </div>
      </div>
    );
  }

  private handleClickWithStopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }
}
